// @ts-nocheck
import { Component } from '@theme/component';
import { morphSection } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';

class SubscriptionUpsellButton extends Component {                         
  constructor() {
    super();
  }


  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleSubscribeButtonClick);

    const parentCartEl = this.closest('cart-items-component');
    this.cartSectionId = parentCartEl?.dataset.sectionId;
  }


  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleSubscribeButtonClick);
  }


  /** @param {MouseEvent} event */
  async #handleSubscribeButtonClick(event) {
    /** @type {HTMLButtonElement|null}} */
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    event.preventDefault();
    
    const productHandle = target.dataset.productHandle;
    const cartItemKey = target.dataset.cartItemKey;
    const variantId = parseInt(target.dataset.variantId);
    const quantity = parseInt(target.dataset.quantity);
    
    target.disabled = true;
    target.textContent = 'Updating...';

    const response = await fetch(`/products/${productHandle}.js`);
    this.productData = await response.json();

    const sellingPlanId = this.#getDefaultSellingPlanId(this.productData);

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionsToUpdateSet = new Set();
    cartItemsComponents.forEach((item, i) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdateSet.add(item.dataset.sectionId);
      }
    });
    const sectionsToUpdate = Array.from(sectionsToUpdateSet).join(',');

    if (!cartItemKey || !quantity || !sellingPlanId || !sectionsToUpdate) {
      const paramsObj = { cartItemKey, quantity, sellingPlanId, sectionsToUpdate };
      console.error('Missing required data attributes for subscription conversion', paramsObj);
      return;
    }

    try {
      await this.#removeOneTimePurchaseItem(cartItemKey, quantity, sellingPlanId, sectionsToUpdate);
      await this.#addSubscriptionItem(variantId, quantity, sellingPlanId, sectionsToUpdate);    
    } catch(error) {
      console.error('Error converting to subscription:', error);
    } finally {
      target.disabled = false;
      target.textContent = 'Subscribe & Save';
    }
  }


  /** @returns {number | undefined} */
  #getDefaultSellingPlanId(productData) {
    // @ts-ignore
    const sellingPlans = productData?.selling_plan_groups.flatMap((planGroup) => planGroup.selling_plans);
    const defaultSellingPlan = sellingPlans.find(plan => !!plan.id);
    return parseInt(defaultSellingPlan?.id);
  }


  /**
   * @param {string} cartItemKey
   * @param {number} quantity
   * @param {number} sellingPlanId
   * @param {string} sectionsToUpdate */
  async #removeOneTimePurchaseItem(cartItemKey, quantity, sellingPlanId, sectionsToUpdate) {
    const response = await fetch(`/cart.js`);
    const cartJson = await response.json();

    const foundItem = cartJson.items
      .map((item, index) => ({ ...item, line_index: index }))
      .find((item) => item.key === cartItemKey && !item.selling_plan_allocation);

    const removeRequestBody = {
      id: cartItemKey,
      quantity: 0,
    };
;
    
    const removeResponse = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(removeRequestBody),
    });
    
    if (!removeResponse.ok) {
      const errorText = await removeResponse.text();
      console.error('Error response from cart/change.js:', errorText);
      alert('The subscription was added but we could not remove the original item. Please remove it manually.');
      throw new Error(`HTTP error! status: ${removeResponse.status}`);
    }
    
    const removeJson = await removeResponse.json();
  }


  /**
   * @param {number} variantId
   * @param {number} quantity
   * @param {number} sellingPlanId
   * @param {string} sectionsToUpdate
   * */
  async #addSubscriptionItem(variantId, quantity, sellingPlanId, sectionsToUpdate) {
    const addRequestBody = {
      items: [{
        id: variantId,
        quantity,
        selling_plan: sellingPlanId,
      }],
      sections: sectionsToUpdate,
    };
    
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(addRequestBody),
    });
    
    if (!addResponse.ok) {
      const errorText = await addResponse.text();
      console.error('Error response from cart/add.js:', errorText);
      if (errorText.includes('Cannot apply selling plan to variant')) {
        alert('This product does not support subscriptions. Please contact customer support for assistance.');
      } else {
        alert('There was an error adding this subscription. Please try again later.');
      }
      throw new Error(`HTTP error! status: ${addResponse.status}`);
    }
    
    const addJson = await addResponse.json();

    if (addJson.sections) {
      Object.entries(addJson.sections).forEach(([key, value]) => {
        morphSection(key, value);
      });
    }

    this.dispatchEvent(
      new CartUpdateEvent({}, this.cartSectionId, {
        itemCount: quantity,
        source: 'cart-items-component',
        sections: addJson.sections || {},
      })
    );
  }
}

if (!customElements.get('subscription-upsell-button')) {
  customElements.define('subscription-upsell-button', SubscriptionUpsellButton);
}